import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs },
} = constants.breakpoints;

const white = constants.colors.brand.white[100];
const grey = constants.colors.ui.neutral[500];
const greyLight = constants.colors.ui.neutral[100];
const { colors } = constants;
const neutral400 = colors.ui.neutral[400];
const neutral600 = colors.ui.neutral[600];

export const modalCss = {
  width: "100%",
  boxShadow: "0px 16px 40px rgba(0, 0, 0, 0.32)",
  zIndex: 99,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const modalWrapper = {
  borderRadius: "16px",
  background: white,
  boxShadow: "0px 2px 6px 0px rgba(29, 29, 29, 0.16)",
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  justifyContent: "center",
  position: "relative" as const,
  padding: 20,
  paddingBottom: 20,
  gap: 10,
  margin: "0px 18px",
  maxWidth: "800px",
  boxSizing: "border-box" as const,
};

export const modalTitle = {
  margin: 0,
  alignSelf: "flex-start" as const,
  textTransform: "uppercase" as const,
  fontSize: 12,
  color: grey,
};

export const modalFooterCss = {
  display: "flex",
  flexDirection: "row" as const,
  alignItems: "center",
  height: "81px",
  width: "100%",
  padding: "16px",
  justifyContent: "flex-end",
  borderTop: "1px solid" + greyLight,
};

export const footerButtonsWrapper = {
  display: "flex",
  flexDirection: "row" as const,
  width: "100%",
  gap: "16px",
  justifyContent: "space-between",
  [mq.downTo(xs)]: {
    width: "auto",
  },
};

export const ButtonCss = {
  margin: 0,
};

export const textAreaCss = {
  root: {
    width: "100%",
  },
  label: {
    color: neutral600,
  },
  text: {
    color: neutral600,

    "&::placeholder": {
      color: neutral400,
    },
  },
};
